import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "parking-calculator" }
const _hoisted_2 = { class: "time-pickers" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "parking-price-headline" }, "Wählen Sie Ihre Parkdauer:", -1)
const _hoisted_4 = { class: "time-input" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "input-label" }, "Einfahrt:", -1)
const _hoisted_6 = { class: "time-input" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "input-label" }, "Ausfahrt:", -1)
const _hoisted_8 = {
  key: 0,
  class: "price-wrapper"
}
const _hoisted_9 = {
  key: 0,
  class: "price-info"
}
const _hoisted_10 = { class: "annual-price-info" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "annual-price-info-text" }, "Achtung, für eine Jahreskarte zahlen Sie maximal", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "prices" }

import ParkingInfoCard from "@/components/ParkingInfoCard.vue";
import { PriceItemInterface, PricesInterface } from "@/interfaces/prices.interface";
import { getDateOneYearFromDate, getDefaultParkingRange, secondsToHoursDaysWeeks } from "@/utils/date.utils";
import { getAnnualPlanPrice, getHighestPrice, getPriceForDuration, updatePricesBasedOnDateRange } from "@/utils/prices.utils";
import VueDatePicker from "@vuepic/vue-datepicker";
import { onMounted, ref } from "vue";

import PricesFromJson from "@/assets/preise.json";
import PricesFromJson2026 from "@/assets/preise2026.json";
import { HoursDaysWeeks } from "@/interfaces/dates.interface";
import { debounce } from "@/utils/debounce";


export default /*#__PURE__*/_defineComponent({
  __name: 'ParkingCalculator',
  setup(__props) {

const setDefaultPrices = () => {
  if (new Date().getFullYear() === 2026) {
    return PricesFromJson2026 as PriceItemInterface[];
  }
  return PricesFromJson as PriceItemInterface[];
};

const currentPrices = setDefaultPrices();

const defaultTimes = getDefaultParkingRange();

const highestPrice = ref(getHighestPrice(currentPrices));
const annualPlanPrice = ref(getAnnualPlanPrice(currentPrices));

const alreadyTracked = ref(false);

const startTime = ref<Date>(defaultTimes[0]);
const endTime = ref<Date>(defaultTimes[1]);

const trackSearch = debounce(() => {
  if (!pricesAvailable() || alreadyTracked.value) return;
  console.log("Parkrechner benutzt");
  window._paq.push(["trackEvent", "Parkrechner", "Parkrechner", "Parkrechner"]);
  alreadyTracked.value = true;
}, 500);

const prices = ref<PricesInterface>();
const time = ref<HoursDaysWeeks>();
const tmpEntryDate = ref<Date>(new Date());

const pricesAvailable = () => {
  if (!prices.value) return false;

  return prices.value.p1 || prices.value.parkhaus || prices.value.p3;
};

const updateDates = (changedDate: Date, isStart: boolean) => {
  if (!changedDate) return;
  if (isStart && changedDate.getTime() !== startTime.value.getTime()) {
    startTime.value = changedDate;
  }
  if (!isStart && changedDate.getTime() !== endTime.value.getTime()) {
    endTime.value = changedDate;
  }

  calculatePrice();
  trackSearch();
};

const calculatePrice = () => {
  if (endTime.value < startTime.value) {
    endTime.value = startTime.value;
  }

  const entryDate = new Date(startTime.value);
  const exitDate = new Date(endTime.value);

  tmpEntryDate.value = entryDate;

  if (exitDate < entryDate) return;

  const seconds = (exitDate.getTime() - entryDate.getTime()) / 1000;

  const hoursDaysWeeks = secondsToHoursDaysWeeks(seconds, currentPrices);

  time.value = hoursDaysWeeks;
  prices.value = getPriceForDuration(currentPrices, hoursDaysWeeks);

  updatePricesBasedOnDateRange(prices.value, startTime.value, endTime.value);
};

onMounted(() => {
  calculatePrice();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_unref(VueDatePicker), {
          modelValue: startTime.value,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((startTime).value = $event)),
            calculatePrice
          ],
          format: "dd.MM.yyyy, HH:mm",
          locale: "de",
          "min-date": new Date(),
          cancelText: "Abbrechen",
          selectText: "Auswählen",
          clearable: false,
          onInternalModelChange: _cache[1] || (_cache[1] = (e) => updateDates(e, true)),
          "input-class-name": "dp-custom-input"
        }, null, 8, ["modelValue", "min-date"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_unref(VueDatePicker), {
          modelValue: endTime.value,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => ((endTime).value = $event)),
            calculatePrice
          ],
          format: "dd.MM.yyyy, HH:mm",
          locale: "de",
          "min-date": startTime.value,
          "max-date": _unref(getDateOneYearFromDate)(new Date(startTime.value)),
          cancelText: "Abbrechen",
          selectText: "Auswählen",
          clearable: false,
          onInternalModelChange: _cache[3] || (_cache[3] = (e) => updateDates(e, false)),
          "input-class-name": "dp-custom-input"
        }, null, 8, ["modelValue", "min-date", "max-date"])
      ])
    ]),
    (pricesAvailable())
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          (prices.value && (prices.value.p1 > highestPrice.value || prices.value.p3 > highestPrice.value || prices.value.parkhaus > highestPrice.value))
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _hoisted_12,
                  _createElementVNode("span", {
                    class: _normalizeClass(`annual-price ${Number(annualPlanPrice.value.p1) ? '' : 'invalid'}`)
                  }, _toDisplayString(annualPlanPrice.value.p1), 3),
                  _createTextVNode(" / "),
                  _createElementVNode("span", {
                    class: _normalizeClass(`annual-price ${Number(annualPlanPrice.value.parkhaus) ? '' : 'invalid'}`)
                  }, _toDisplayString(annualPlanPrice.value.parkhaus), 3),
                  _createTextVNode(" / "),
                  _createElementVNode("span", {
                    class: _normalizeClass(`annual-price ${Number(annualPlanPrice.value.p3) ? '' : 'invalid'}`)
                  }, _toDisplayString(annualPlanPrice.value.p3), 3)
                ]),
                _createElementVNode("div", {
                  class: "show-annual-price",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (endTime.value = _unref(getDateOneYearFromDate)(new Date(startTime.value))))
                }, " Jahreskarte auswählen ")
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prices.value, (price, name, index) => {
              return (_openBlock(), _createBlock(ParkingInfoCard, {
                key: index,
                name: name,
                price: price
              }, null, 8, ["name", "price"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})